module.exports = __webpack_public_path__ + "static/media/jasminechild.ed18862e.webp";